module.exports = __webpack_public_path__ + "img/seltzer_button.ce82293b.png";